<template>
  <div>
    <div id="infoBox">
      <div class="_info_Box" name="infoBox">
        <div v-show="clickSelect" style="position:relative;">
          <div class="rightBoxA"></div>
          <div class="rightBox"></div>
          <ul class="fileSelectUl">
            <li
              @click="bookmarkFunc(true, '1', 'unread')"
              :class="{ navLiClass: isFlagLiClass === 'unread' }"
            >{{ $t('infoBox.function.put.unread') }}</li>
            <li
              @click="bookmarkFunc(false, '0', 'start')"
              :class="{ navLiClass: isFlagLiClass === 'start' }"
            >{{ $t('infoBox.function.put.start') }}</li>
            <li
              @click="bookmarkFunc(true, '0', 'unstart')"
              :class="{ navLiClass: isFlagLiClass === 'unstart' }"
            >{{ $t('infoBox.function.del.start') }}</li>
          </ul>
        </div>
        <div class="_div_box_card">
          <el-card class="box-card">
            <template>
              <div slot="header" class="clearfix">
                <div class="_div">
                  <input
                    @focus="inputFocus"
                    @blur="inputBlur"
                    :class="{ _inputFocus:isFocus === true }"
                    type="text"
                    v-model="search"
                    class="_input"
                    :placeholder="$t('infoBox.input.search.placeholder')"
                  >
                  <i class="_sprite_class" @click="searchClick"></i>
                </div>
                <div
                  style="height:43px;"
                  class="headerBorderBottom"
                  :style="isInfoHeader || isbackClolorBox ? 'background-color: rgba(51, 51, 51, 0.05);' : 'background-color: rgba(0, 181, 226, 0.1);' "
                >
                  <el-checkbox
                    :indeterminate="isIndeterminate"
                    v-model="checkAll"
                    :disabled="isbackClolorBox"
                    @change="handleCheckAllChange"
                    style="margin-top:10px;"
                  ></el-checkbox>
                  <span
                    class="el-icon-caret-bottom"
                    style="margin-left:5px;cursor:pointer;"
                    :style=" isbackClolorBox ? 'cursor: not-allowed;' : '' "
                    @click="clickSelectKind()"
                  ></span>
                  <div class="_div_spans" v-show="!isInfoHeader">
                    <span
                      @click="unReadStartFun('unread', 'hasRead', false)"
                      :class="{ unread_started_class: isUnread === true }"
                    >{{ $t('infoBox.filter.unread') }}</span>
                    <span class="read_separated_start">｜</span>
                    <span
                      @click="unReadStartFun('start', 'hasBookmark', true)"
                      :class="{ unread_started_class: isStart === true }"
                    >{{ $t('infoBox.filter.start') }}</span>
                  </div>
                  <div style="float:right;margin-top: 12px;" v-show="isInfoHeader">
                    <img class="infoDeleLeft" @click="deleteMsg(null, '2', 'delete')" src="../../assets/img/infobox/info_dele_left.png" alt>
                    <span class="readChange" @click="bookmarkFunc(false, '1', 'read')">{{ $t('infoBox.function.put.read') }}</span>
                    <span class="readChangeSelect">｜</span>
                    <div style="display:inline-block;margin-right:15px;" @click="clickSelectFunc()">
                      <img
                        class="infoSelect"
                        src="../../assets/img/infobox/info_multi_select.png"
                        alt
                      >
                    </div>
                  </div>
                  <!-- 已读/未读/加星/未加星 -->
                  <div v-show="selectKind" style="position:relative;">
                    <div>
                      <div class="infoRightBoxA"></div>
                      <div class="infoRightBox"></div>
                      <ul class="infoSelectUl">
                        <li
                          @click="controlSelectionFunc(null ,'all')"
                          :class="{ navLiClass: isFlagClass === 'all' }"
                        >{{ $t('infoBox.select.all') }}</li>
                        <li
                          @click="controlSelectionFunc( '1', 'read')"
                          :class="{ navLiClass: isFlagClass === 'read' }"
                        >{{ $t('infoBox.select.read') }}</li>
                        <li
                          @click="controlSelectionFunc( '1', 'unread')"
                          :class="{ navLiClass: isFlagClass === 'unread' }"
                        >{{ $t('infoBox.select.unread') }}</li>
                        <li
                          @click="controlSelectionFunc( '0', 'start')"
                          :class="{ navLiClass: isFlagClass === 'start' }"
                        >{{ $t('infoBox.select.start') }}</li>
                        <li
                          @click="controlSelectionFunc( '0', 'unstart')"
                          :class="{ navLiClass: isFlagClass === 'unstart' }"
                        >{{ $t('infoBox.select.unstart') }}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <el-checkbox-group
                ref="isShowcheckboxDom"
                :class=" !isShowScroll ? 'unScroll' : 'scrollShow' "
                v-model="checkedCities"
                @change="handleCheckedCitiesChange"
                :style="isbackClolorBox ? 'background-color: rgba(51, 51, 51, 0.05);height: 556px;' : 'height: 100%;' "
              >
              <div v-loading="loading" style="height: 100%">
                <div v-for="(o, index) in dataList" :key="index" class="text item">
                  <!-- {{'列表内容 ' + o }} -->
                  <div :style="!index ? 'position:relative;' : 'position:relative;border-top: 1px solid rgba(51, 51, 51, 0.3);'">
                    <div style="display:flex;" :style="index === slectIndex ? slectStyle: '' ">
                      <el-checkbox :label="index" :key="index"></el-checkbox>
                      <div
                        @click="clickInfoBox(o)"
                        class="infoComponent"
                        :class=" { selectedBack: o.hasRead  === true } "
                      >
                        <h5 class="infoComponentTitle">{{o.notification.title}}</h5>
                        <span
                          class="infoContent"
                        >{{o.notification.message.length > 30 ? o.notification.message.substring(0, 45) + '. . .' : o.notification.message}}</span>
                        <span class="systemInfo">系統通知</span>
                        <p class="infoComponentTime">{{ momentFunc(o.notification.createdAt) }}</p>
                      </div>
                      <div class="startSuperItem">
                        <img
                          style="cursor:pointer;"
                          :src=" o.hasBookmark ? requireImage.startS : requireImage.unStartS "
                          alt
                          class="startSuperItemImg"
                          @click.stop="startFunc([o.notification.notificationId], o.hasBookmark, '0')"
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </el-checkbox-group>
            </template>
            <!-- 右边的 card -->
          </el-card>
          <el-card class="box-card" shadow="never" ref="boxDom">
            <div style="width:532px;margin:auto;">
              <div v-for="(o, index) in detailList" :key="index">
                <div class="watchInfoSuper">
                  <img
                    style="cursor:pointer;"
                    @click="startFunc([o.notification.notificationId], o.hasBookmark, '0')"
                    class="watchInfoSuperImg"
                    :src=" o.hasBookmark ? requireImage.startL : requireImage.unStartL "
                  >
                  <span class="start_dele_line">|</span>
                  <img @click="deleteMsg([o.notification.notificationId], null, '2', true)" class="startDeleImg" src="../../assets/img/infobox/info_dele.png" alt>
                  <span
                    style="cursor:pointer;"
                    class="watchLast"
                    @click="changeMessage(o, 'last', -1)"
                  >
                    <img
                      style="width: 6.7px;height: 11.3px;cursor:pointer;"
                      src="../../assets/img/infobox/info_left.png"
                      alt
                    >
                  </span>
                  <span
                    style="cursor:pointer;"
                    class="watchNext"
                    @click="changeMessage(o, 'next', 1)"
                  >
                    <img
                      style="width: 6.7px;height: 11.3px;cursor:pointer;"
                      src="../../assets/img/infobox/info_right.png"
                      alt
                    >
                  </span>
                </div>
                <div class="manageSuperItem">
                  <img class="manageTeamImg" src="../../assets/img/infobox/info_header.png" alt>
                  <span class="nuwaManageTeam">Nuwa developer {{ $t('infoBox.detail.management') }}</span>
                </div>
                <div class="text item" style="border-bottom:none;">
                  <p class="publicLineStyle"></p>
                  <div>
                    <h5 class="manageTitleH5">{{ o.notification.title }}</h5>
                    <p class="manageTime">{{ momentFunc(o.notification.createdAt, true) }}</p>
                  </div>
                  <div style="display: inline-grid;float: right;"></div>
                </div>
                <div class="watchMessageBox">
                  <p class="publicLineStyle"></p>
                  <div class="watchMessageAll">
                    <p
                      ref="isShowAllDom"
                      class="wordOverflow"
                    >
                    {{ o.notification.message }}
                    </p>
                  </div>
                </div>
              </div>
              <!-- 没有信息 -->
              <div v-show="!detailList.length" class="noMessageBox">
                <img
                  class="noMessageClass"
                  src="../../assets/img/infobox/nuwa_developer_info.png"
                  alt
                >
                <p>{{ (isUnread && !dataList.length) ? $t('infoBox.detail.null.unread.top') : ''}}</p>
                <p>{{ (isStart && !dataList.length) ? $t('infoBox.detail.null.start.top') : ''}}</p>
                <p>{{ (isStart || isUnread) && !detailList.length && dataList.length ? $t('infoBox.detail.null.nochoose.top') : ''}}</p>
                <p>{{ !isStart & !isUnread && !dataList.length ? $t('infoBox.detail.null.all.top') : ''}}</p>
                <p>{{ (isUnread && !dataList.length) ? $t('infoBox.detail.null.unread.bottom') : '' }}</p>
                <p>{{ (isStart && !dataList.length) ? $t('infoBox.detail.null.start.bottom') : ''}}</p>
                <p>{{ (isStart || isUnread) && !detailList.length && dataList.length ? $t('infoBox.detail.null.nochoose.bottom') : ''}}</p>
                <p>{{ !isStart & !isUnread && !dataList.length ? $t('infoBox.detail.null.all.bottom') : ''}}</p>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
const cityOptions = []
export default {
    data () {
        return {
            search: '',
            checkAll: false,
            checkedCities: [],
            cities: cityOptions,
            isIndeterminate: false,
            // data
            dataList: [],
            detailList: [],
            elementItem: [
                { path: 'infoBox', msg: 'header.IconNavHeader.route.name.messageClip' },
                true,
                { path: 'notificationSet', msg: 'header.IconNavHeader.route.name.notificationSet' }
            ],
            iconNavTitle: '通知中心',
            hasBookmark: false,
            clickSelect: false,
            checkBoxArr: [],
            isUnread: false,
            isStart: false,
            requireImage: {
                unStartS: require('../../assets/img/infobox/info_unstart_s.png'),
                startS: require('../../assets/img/infobox/info_start_s.png'),
                unStartL: require('../../assets/img/infobox/info_unstart_l.png'),
                startL: require('../../assets/img/infobox/info_start_l.png')
            },
            isFlagLiClass: '',
            isFlagClass: '',
            selectKind: false,
            slectIndex: null,
            slectStyle: '',
            isInfoHeader: false,
            slectInfoId: '',
            isbackClolorBox: false,
            isShowScroll: false,
            isInfoMessage: false,
            isFocus: false,
            loading: false
        }
    },
    mounted () {
        // 数据初始化
        this.getInfoData(null)
        // 账户 / 通知 header
        this.$store.state.iconNavHeader = this.elementItem
    },
    methods: {
        deleteMsg (type, species, param, flag) {
            this.isFlagClass = null
            this.$confirm(`${this.$t('message.prompt.common.content.del')} ${this.$t('message.prompt.common.title.continue')}`, this.$t('message.prompt.common.title.NWTeam'), {
                confirmButtonText: this.$t('message.prompt.common.title.tool.ok'),
                cancelButtonText: this.$t('userRoles.common.dialog.button.cancle'),
                type: 'warning'
            }).then(() => {
                setTimeout(() => {
                    if (flag) {
                        this.startFunc(type, species, param)
                    } else {
                        this.bookmarkFunc(type, species, param)
                    }
                }, 0)
            }).catch(() => {
            })
        },
        inputFocus () {
            this.isFocus = true
        },
        inputBlur () {
            this.isFocus = false
        },
        // is show scroll
        isShowScrollFunc (len) {
            if (len > 3) {
                this.isShowScroll = true
            } else {
                this.isShowScroll = false
            }
        },
        // 搜索
        searchClick () {
            let path = `/developer/notifications?keyword=${
                this.search
            }`
            this._api.request('get', path)
                .then(response => {
                    let data = response.data.data
                    if (response.status === 200) {
                        this.dataList = data.payload
                        if (this.dataList.length === 0) {
                            this.handleState()
                            this.clickInfoBox()
                        }
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },
        clickSelectFunc () {
            this.clickSelect = !this.clickSelect
            // 关闭消除选中
            if (!this.clickSelect) {
                this.isFlagLiClass = null
            }
        },
        clickSelectKind () {
            if (this.isbackClolorBox) {
                this.selectKind = false
                return
            }
            this.selectKind = !this.selectKind
        },
        // update api function
        startFunc (ids, hasBookmark, species) {
            this.isFlagClass = null
            let path = `/developer/notification`
            let type
            if (species === '0') {
                if (hasBookmark) {
                    type = 'unbookmark'
                } else {
                    type = 'bookmark'
                }
            } else if (species === '1') {
                if (hasBookmark) {
                    type = 'unread'
                } else {
                    type = 'read'
                }
            } else {
                type = 'delete'
            }

            this._api.request(
                'put',
                path,
                {
                    type,
                    ids
                }
            )
                .then(response => {
                    // let data = response.data.data;
                    if (response.status === 200) {
                        this.dataList = this.dataList.map(element => {
                            ids.map(item => {
                                if (
                                    element.notification.notificationId === item
                                ) {
                                    if (species === '0') {
                                        element.hasBookmark = !hasBookmark
                                    } else if (species === '1') {
                                        element.hasRead = !hasBookmark
                                    }
                                    return element
                                }
                                if (
                                    this.detailList.length > 0 &&
                                    this.detailList[0].notification
                                        .notificationId ===
                                        element.notification.notificationId
                                ) {
                                    this.detailList[0] = element
                                }
                            })
                            return element
                        })
                    }
                    // 更新 dataList
                    if (this.isUnread) {
                        this.getInfoData('read', 'hasRead', false)
                    } else if (this.isStart) {
                        this.getInfoData('start', 'hasBookmark', true)
                    } else if (type === 'delete') {
                        this.getInfoData(null)
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },
        // 标记星号 已读 未读（改变状态）
        bookmarkFunc (hasBookmark, species, type) {
            this.isFlagLiClass = type
            // 除了全选还有单选
            if (this.checkAll && !this.isIndeterminate) {
                this.startFunc(
                    this.dataList.map(item => item.notification.notificationId),
                    hasBookmark,
                    species
                )
            } else {
                if (this.checkBoxArr.length === 0) {
                    return
                }
                let ids = []
                this.checkBoxArr.forEach(item => {
                    ids.push(this.dataList.filter((element, index) => {
                        if (index === item) {
                            return element.notification.notificationId
                        }
                    })[0])
                })
                this.startFunc(
                    ids.map(item => item.notification.notificationId),
                    hasBookmark,
                    species
                )
            }
        },
        // checkAll
        handleCheckAllChange (val) {
            val ? (this.isFlagClass = 'all') : (this.isFlagClass = null)
            this.isInfoHeader = val
            if (!val) {
                this.clickSelect = false
                this.isFlagLiClass = null
            }
            this.checkedCities = val ? cityOptions : []
            this.isIndeterminate = false
        },
        // 自定义check
        handleCheckedCitiesChange (value) {
            !value.length && (this.isFlagLiClass = null)
            this.selectKind = false
            this.isFlagClass = null
            let checkedCount = value.length
            this.checkAll = checkedCount === this.cities.length
            this.isIndeterminate =
                checkedCount > 0 && checkedCount < this.cities.length
            if (!this.isIndeterminate && !this.checkAll) {
                this.isInfoHeader = false
                this.clickSelect = false
                this.isFlagLiClass = null
            } else {
                this.isInfoHeader = true
            }
            this.checkBoxArr = value
        },
        // 转换时间
        momentFunc (date, type) {
            if (!date) {
                return
            }
            if (type) {
                return moment(date).format('YYYY/MM/DD')
            }

            if (
                parseInt(moment(date).format('YYYY')) <
                parseInt(moment(new Date()).format('YYYY'))
            ) {
                return moment(date).format('YYYY')
            } else if (
                moment(date).format('MM/DD') ===
                moment(new Date()).format('MM/DD')
            ) {
                return moment(date).format('h:mma')
            } else if (
                moment(new Date()).format('MM') === moment(date).format('MM') &&
                parseInt(moment(new Date()).format('DD')) -
                    parseInt(moment(date).format('DD')) <=
                    7
            ) {
                return moment(date)
                    .startOf('day')
                    .fromNow()
            }
            return moment(date).format('MM/DD')
        },
        // 显示通知信息详情
        clickInfoBox (obj) {
            if (obj && obj.notification) {
                this.slectInfoId = obj.notification.notificationId
                this.dataList.forEach((element, index) => {
                    if (
                        element.notification.notificationId === this.slectInfoId
                    ) {
                        this.slectIndex = index
                        if (this.detailList.length === 0) {
                            this.detailList.push(obj)
                        } else {
                            this.detailList.splice(0, 1, obj)
                        }
                    }
                })
                this.slectStyle = 'background:rgba(0, 181, 226, 0.05);'
            } else {
                if (this.slectInfoId) {
                    let flag = false
                    this.dataList.forEach((element, index) => {
                        if (
                            element.notification.notificationId ===
                            this.slectInfoId
                        ) {
                            this.slectIndex = index
                            this.detailList.splice(0, 1, element)
                            flag = true
                            this.slectStyle =
                                'background:rgba(0, 181, 226, 0.05);'
                            this.$nextTick(() => {
                                this.scrollTopEvent(element, index)
                            })
                        }
                    })
                    if (!flag) {
                        this.detailList = []
                        this.slectStyle = ''
                    }
                }
            }
        },
        // 全选/已读/未读/加星/未加星
        controlSelectionFunc (species, type) {
            this.isInfoHeader = true
            this.isFlagClass = type
            // 全选
            if (type === 'all') {
                // 选框样式
                this.isIndeterminate = false
                // 控制全选
                this.checkAll = true
                // 全选数据
                this.checkedCities = cityOptions
                return
            }
            // 已读 / 未读
            if (species === '0') {
                if (type === 'start') {
                    this.styleCheckBox('hasBookmark', true)
                } else {
                    this.styleCheckBox('hasBookmark', false)
                }
            } else {
                if (type === 'read') {
                    this.styleCheckBox('hasRead', true)
                } else {
                    this.styleCheckBox('hasRead', false)
                }
            }
        },
        // 控制checkbox 的样式
        styleCheckBox (key, type) {
            this.checkBoxArr.length = 0
            this.dataList.forEach((element, index) => {
                if (element[key] === type) {
                    this.checkBoxArr.push(index)
                }
            })
            this.checkedCities = this.checkBoxArr
            // 没有任何信息选中
            if (this.checkBoxArr.length === 0) {
                this.checkedCities = []
                this.checkAll = false
                this.isIndeterminate = false
                this.isInfoHeader = false
                this.clickSelect = false
                this.isFlagLiClass = null
                return
            }
            if (this.checkBoxArr.length === this.dataList.length) {
                this.isIndeterminate = false
                this.checkAll = true
            } else {
                this.isIndeterminate = true
            }
        },
        // 切换信息
        changeMessage (obj, type, val) {
            this.dataList.forEach((item, index) => {
                if (
                    item.notification.notificationId ===
                    obj.notification.notificationId
                ) {
                    if (this.dataList[index + val]) {
                        this.clickInfoBox(
                            this.dataList[index + val],
                            index + val
                        )
                        // 这是scrollTop Events
                        this.scrollTopEvent(this.dataList[index + val], index + val)
                    }
                }
            })
        },
        // 筛选 未读 和已加星号
        unReadStartFun (type, key, flag) {
            this.isDataListFilter = true
            if (type === 'unread') {
                this.isUnread = !this.isUnread
                this.isStart = false
            } else {
                this.isStart = !this.isStart
                this.isUnread = false
            }
            if (this.isStart || this.isUnread) {
                this.getInfoData(type, key, flag)
            } else {
                this.getInfoData(null)
            }
        },
        // get data function
        getInfoData (type, key, flag) {
            // 这是请求infoData
            this.loading = true
            let path =
                'developer/notifications'
            this._api.request('get', path)
                .then(response => {
                    let data = response.data.data
                    if (response.data.data.payload.length === 0) {
                        this.dataList = data.payload
                        this.isbackClolorBox = true
                        this.isShowScrollFunc(this.dataList.length)
                        this.loading = false
                        this.detailList = []
                        return
                    }

                    if (response.status === 200) {
                        this.loading = false
                        this.dataList = []
                        cityOptions.length = 0
                        data.payload.forEach((item, index) => {
                            cityOptions.push(index)
                            if (type === null) {
                                this.dataList.push(item)
                            } else {
                                if (item[key] === flag) {
                                    this.dataList.push(item)
                                }
                            }
                        })
                        // this.dataList = []
                        // 默认显示第一条
                        if (!this.slectInfoId && !this.$route.params.id) {
                            this.clickInfoBox(this.dataList[0])
                        } else if (this.slectInfoId) {
                            if (this.dataList.some(s => s.notification.notificationId === this.slectInfoId)) {
                                this.clickInfoBox()
                            } else {
                                this.clickInfoBox(this.dataList[0])
                            }
                        } else {
                            if (this.$route.params.id) {
                                this.slectInfoId = this.$route.params.id.notification.notificationId
                                this.clickInfoBox()
                            } else {
                                this.clickInfoBox()
                            }
                        }
                        // 没有数据 处理一些状态
                        this.handleState()
                        this.isShowScrollFunc(this.dataList.length)
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },
        // 处理一些状态
        handleState () {
            if (this.dataList.length === 0) {
                if (this.isUnread || this.isStart) {
                    this.checkAll = false
                    this.isInfoHeader = false
                    this.clickSelect = false
                    this.isFlagLiClass = null
                    this.isbackClolorBox = true
                    this.isIndeterminate = false
                    this.checkBoxArr.length = 0
                    this.checkedCities = []
                } else {
                    this.isbackClolorBox = true
                    this.isFlagClass = null
                    this.selectKind = false
                }
                this.isFlagClass = null
                this.selectKind = false
            } else {
                this.isbackClolorBox = false
            }
        },
        scrollTopEvent (obj, index) {
            if (index + 1 > 3) {
                this.$refs.isShowcheckboxDom.$el.scrollTop = ((index + 1) - 3) * 140
            } else {
                this.$refs.isShowcheckboxDom.$el.scrollTop = 0
            }
        }
    },
    watch: {
        search () {
            if (!this.search) {
                this.isStart = false
                this.isUnread = false
                this.getInfoData(null)
            }
            return this.search
        }
    },
    updated () {
        if (this.$refs.isShowAllDom && this.$refs.isShowAllDom[0]) {
            if (this.$refs.isShowAllDom[0].scrollHeight > this.$refs.isShowAllDom[0].clientHeight) {
                this.$refs.isShowAllDom[0].classList.add('itemScrollShow')
            } else {
                this.$refs.isShowAllDom[0].classList.remove('itemScrollShow')
            }
        }
    }
}
</script>

<style scoped>
#infoBox {
    width: 1078px;
    margin: auto;
    margin-top: 25px;
    padding-bottom: 73px;
    font-weight: 300;
    font-family: sans-serif;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    color: #333333;
}
p {
    margin: 0px;
}
.headerBorderBottom{
    border-bottom: 1px solid rgba(51, 51, 51, 0.3);
}
._input {
    width: 348px;
    height: 34px;
    border-radius: 4px;
    background-color: #ffffff;
    outline: none;
    border: 1px solid rgba(51, 51, 51, 0.4);
    padding-left: 30px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    opacity: 0.5;
    transition: 0.2s;
    font-size: 14px;
}
._inputFocus {
    border: 2px solid rgba(0, 224, 218, 0.5) !important;
    transition: 0.2s;
}
.noMessageBox {
    width: 510px;
    margin: auto;
    font-size: 16px;
    letter-spacing: 0.9px;
    text-align: center;
}
.noMessageBox p {
    margin: 0px;
    margin-bottom: 4px;
}
.noMessageClass {
    width: 167px;
    margin: auto;
    display: block;
    margin-top: 146px;
    margin-bottom: 44px;
}
.wordOverflow {
    padding: 0px 10px;
    word-wrap: break-word;
    margin: 0px;
    height: 365px;
    word-break: break-all;
}
.unScroll {
    overflow: hidden;
    border: 1px solid rgba(100, 90, 90, 0.2);
    border-top: none;
}
.itemUnScroll {
    overflow: hidden;
}
.itemScrollShow {
    overflow: scroll;
    overflow-x: hidden;
}
.scrollShow {
    overflow: scroll;
    overflow-x: hidden;
    border: 1px solid rgba(100, 90, 90, 0.2);
    border-top: none;
    scroll-behavior: smooth;
}
ul {
    padding: 0px;
    margin: 0px;
}
/* zplin */
.selectedBack {
    background-color: rgba(51, 51, 51, 0.05);
}
.selectBack {
    background-color: rgba(0, 181, 226, 0.05);
}
.infoSelect {
    width: 19px;
    height: 20px;
    vertical-align: middle;
    cursor: pointer;
}
.infoDeleLeft {
    width: 21px;
    height: 24px;
    vertical-align: middle;
}
.readChangeSelect {
    width: 17px;
    height: 24px;
    font-size: 16px;
    letter-spacing: 0.9px;
    margin: 0px 14px;
}
.readChange {
    width: 85px;
    height: 24px;
    font-size: 16px;
    letter-spacing: 0.9px;
    margin-left: 14px;
}
.rightBoxA {
    width: 0;
    height: 0;
    border-width: 0 6px 6px;
    border-style: solid;
    border-color: transparent transparent rgba(51, 51, 51, 0.2);
    margin: 0px auto;
    position: absolute;
    top: 84.8px;
    left: 319px;
    z-index: 2;
}
.infoRightBoxA {
    width: 0;
    height: 0;
    border-width: 0 6px 6px;
    border-style: solid;
    border-color: transparent transparent rgba(51, 51, 51, 0.2);
    margin: 0px auto;
    position: absolute;
    top: 2.8px;
    left: 45px;
    z-index: 2;
}
.rightBox {
    width: 0;
    height: 0;
    border-width: 0 5px 5px;
    border-style: solid;
    border-color: transparent transparent #fff;
    margin: 0px auto;
    position: absolute;
    top: 86px;
    left: 320px;
    z-index: 3;
}
.infoRightBox {
    width: 0;
    height: 0;
    border-width: 0 5px 5px;
    border-style: solid;
    border-color: transparent transparent #fff;
    margin: 0px auto;
    position: absolute;
    top: 4px;
    left: 46px;
    z-index: 3;
}
.navLiClass {
    color: #00b5e2 !important;
    font-weight: 500 !important;
    box-sizing: border-box;
}
.fileSelectUl li:hover {
    background-color: rgba(0, 224, 218, 0.1);
}
.infoSelectUl li:hover {
    background-color: rgba(0, 224, 218, 0.1);
}
.fileSelectUl li {
    list-style: none;
    text-align: center;
    height: 28px;
    font-size: 12px;
    line-height: 28px;
    letter-spacing: 0.7px;
    text-align: left;
    padding: 0px 10px;
}
.infoSelectUl li {
    list-style: none;
    text-align: center;
    height: 28px;
    font-size: 12px;
    line-height: 28px;
    letter-spacing: 0.7px;
    text-align: left;
    padding: 0px 10px;
}
.fileSelectUl {
    padding-top: 6px;
    padding-bottom: 4px;
    border: solid 1px rgba(51, 51, 51, 0.2);
    border-radius: 5px;
    background-color: #ffffff;
    position: absolute;
    z-index: 2;
    left: 282px;
    top: 90px;
}
.infoSelectUl {
    padding-top: 6px;
    padding-bottom: 4px;
    border: solid 1px rgba(51, 51, 51, 0.2);
    border-radius: 5px;
    background-color: #ffffff;
    position: absolute;
    z-index: 2;
    left: 16px;
    top: 8px;
}
.watchLast {
    display: inline-block;
    width: 30px;
    height: 30px;
    border-radius: 2px;
    background-color: rgba(51, 51, 51, 0.1);
    text-align: center;
    line-height: 30px;
    margin-left: 17px;
}
.watchNext {
    display: inline-block;
    width: 30px;
    height: 30px;
    border-radius: 2px;
    background-color: rgba(51, 51, 51, 0.1);
    text-align: center;
    line-height: 30px;
    margin-left: 3px;
}
.startDeleImg {
    width: 21px;
    vertical-align: middle;
    height: 24px;
}
.startSuperItemImg {
    width: 16px;
    height: 16px;
}
.watchInfoSuperImg {
    width: 24px;
    height: 24px;
    vertical-align: middle;
}
.publicLineStyle {
    height: 1.4px;
    margin: 0px;
    background: rgba(51, 51, 51, 0.1);
}
.watchMessageBox {
    height: 378px;
    box-sizing: border-box;
    padding: 8px 0px;
    border-radius: 4px;
    background-color: rgba(51, 51, 51, 0.06);
}
.watchMessageAll {
    height: 363.7px;
    font-size: 16px;
    letter-spacing: 0.9px;
}
.manageTime {
    margin: 0px 0px 6px 0px;
    height: 18px;
    font-size: 12px;
    letter-spacing: 0.7px;
    color: rgba(51, 51, 51, 0.3);
}
.manageTitleH5 {
    margin: 13px 0px 6px 0px;
    height: 29px;
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 1.1px;
}
.manageSuperItem {
    padding: 54px 0px 10px 0px;
}
.nuwaManageTeam {
    width: 152px;
    height: 18px;
    font-size: 12px;
    letter-spacing: 0.7px;
}
.manageTeamImg {
    width: 26px;
    vertical-align: middle;
    /* height: 26px; */
    margin-right: 14px;
    margin-top: -2px;
}
.watchInfoSuper {
    float: right;
    margin-top: 40px;
}
.startSuperItem {
    position: absolute;
    top: 5px;
    right: 14px;
}
.infoComponentTime {
    width: 275px;
    height: 18px;
    font-size: 12px;
    letter-spacing: 0.7px;
    color: rgba(51, 51, 51, 0.3);
    margin: 0px;
}
.infoContent {
    display: block;
    width: 275px;
    height: 54px;
    font-size: 12px;
    letter-spacing: 0.7px;
    color: rgba(51, 51, 51, 0.8);
}
.infoComponent {
    margin-left: 15px;
    width: 100%;
    height: 136px;
    font-size: 12px;
    padding: 0px 14px 0px 9px;
}
.infoComponentTitle {
    margin: 5px 0px 5px 0px;
    height: 24px;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.9px;
}
.unread_started_class {
    font-weight: 500 !important;
}
.read_separated_start {
    margin: 0px 3px;
    cursor: default !important;
}
.start_dele_line {
    width: 4px;
    height: 18px;
    font-size: 12px;
    letter-spacing: 0.7px;
    margin: 0px 14px;
}
.systemInfo {
    display: block;
    width: 64px;
    height: 18px;
    border-radius: 9px;
    background-color: rgba(0, 181, 226, 0.1);
    text-align: center;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.7px;
    border-radius: 9px;
    border: 1px solid;
    border-color: rgba(0, 181, 226, 0.5);
    margin: 5px 0px;
    color: rgba(51, 51, 51, 0.8);
}
._div_spans span {
    cursor: pointer;
    display: inline-block;
    text-align: center;
    height: 24px;
    font-size: 16px;
    letter-spacing: 0.9px;
}
._div {
    display: inline-block;
    width: 100%;
    position: relative;
    height: 34px;
}

._sprite_class {
    display: inline-block;
    width: 14px;
    height: 14px;
    background-image: url('../../assets/img/infobox/info_search.png');
    position: absolute;
    left: 10px;
    top: 9px;
    cursor: pointer;
    text-align: center;
    background-size: 100%;
}
._div_spans {
    float: right;
    margin-right: 14px;
    line-height: 43px;
}

._div_box_card {
    display: inline-flex;
    height: 564px;
}
.text {
    font-size: 14px;
}

.item {
    margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: '';
}
.clearfix:after {
    clear: both;
    color: #000;
}

.box-card {
    width: 714px;
    border: 1px solid rgba(51, 51, 51, 0.2);
}
</style>

<style>
/*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
#infoBox ::-webkit-scrollbar {
    width: 7px; /*对垂直流动条有效*/
    height: 7px; /*对水平流动条有效*/
}
/*定义滚动条的轨道颜色、内阴影及圆角*/
#infoBox ::-webkit-scrollbar-track {
    /* -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); */
    background-color: rgba(51, 51, 51, 0.2);
    border-radius: 3px;
}
/*定义滑块颜色、内阴影及圆角*/
#infoBox ::-webkit-scrollbar-thumb {
    border-radius: 7px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: rgba(255, 255, 255, 0.8);
}
#infoBox .el-icon-caret-bottom:hover{
    opacity: .5;
}
#infoBox [class*=" el-icon-"], [class^=el-icon-]{
    font-weight: 1000!important;
}
#infoBox .el-checkbox__input.is-checked + .el-checkbox__label {
    display: none;
}
#infoBox .el-checkbox__label {
    display: none;
}
#infoBox .el-checkbox__inner {
    border-color: #afa9a981;
}

#infoBox .el-card__body {
    padding: 0;
    height: 487px;
}

.item {
    margin-bottom: 0 !important;
}

#infoBox .el-card__header {
    border-bottom: none;
    padding: 0px;
}

/* 左边dialog&width */
#infoBox .el-card.is-always-shadow {
    width: 348px;
    margin-right: 16px;
    border: none;
    border-bottom: 1px solid rgba(100, 90, 90, 0.2);
}

#infoBox .el-checkbox {
    margin-left: 24px;
    height: 0px;
    margin-top: 3px;
}
#infoBox .el-checkbox__input.is-checked .el-checkbox__inner {
    background: rgba(51, 51, 51, 0.5);
}
#infoBox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background: rgba(51, 51, 51, 0.5);
}
#infoBox .el-checkbox-group {
    height: 100%;
}
#infoBox .el-checkbox__input.is-disabled .el-checkbox__inner {
    background-color: rgba(51, 51, 51, 0.1);
}
</style>
